import { Routes } from '@angular/router';
import { AdminPanelRoutes } from '@core';
import {
  AdminHomeComponent,
  FeatureFlagsComponent,
  GamesComponent,
  GamesStatsComponent,
  GeneratePostComponent,
  UsersComponent,
  UsersStatsComponent,
  VersionInfoComponent
} from './components';

export const AdminPanelRouting: Routes = [
  {
    path: AdminPanelRoutes.ROOT,
    component: AdminHomeComponent
  },
  {
    path: AdminPanelRoutes.VERSION_INFO,
    component: VersionInfoComponent
  },
  {
    path: AdminPanelRoutes.USERS,
    component: UsersComponent
  },
  {
    path: AdminPanelRoutes.GAMES,
    component: GamesComponent
  },
  {
    path: AdminPanelRoutes.GENERATE_POST,
    component: GeneratePostComponent
  },
  {
    path: AdminPanelRoutes.GAMES_STATS,
    component: GamesStatsComponent
  },
  {
    path: AdminPanelRoutes.USERS_STATS,
    component: UsersStatsComponent
  },
  {
    path: AdminPanelRoutes.FEATURE_FLAGS,
    component: FeatureFlagsComponent
  }
];
